import { FormValues } from '@wix/form-viewer';
import { OwnerLogger, VisitorLogger } from '@wix/yoshi-flow-editor';
import { WixFormFields } from '../../../../types/wix-forms';
import { IntakeFormErrorType } from '../../../../types/errors';
import { hasEmailMismatchWithIntakeForms } from '../../../../utils/intakeFormUtils';
import { IntakeForms } from '../../../../utils/state/types';
import { bookingsBoWaiverAppSrc16Evid66 } from '@wix/bi-logger-bookings-data/v2';
import {
  intakeFormsErrorDefaults,
  intakeFormsErrorSuffixes,
} from '../../../../utils/bi/consts';

export interface IntakeFormValidationActions {
  addError: (errorType: IntakeFormErrorType) => void;
  removeErrors: (errorTypes: IntakeFormErrorType[]) => void;
}

export const handleIntakeFormEmailValidation = (
  values: FormValues,
  intakeForms: IntakeForms | undefined,
  actions: IntakeFormValidationActions,
  bi?: OwnerLogger | VisitorLogger,
): void => {
  const emailFieldValue = values[WixFormFields.EMAIL];

  if (!emailFieldValue) {
    return;
  }

  actions.removeErrors([
    IntakeFormErrorType.COMPLETE_CLIENT_DETAILS_BEFORE_INTAKE,
  ]);

  const emailMismatch = hasEmailMismatchWithIntakeForms(
    emailFieldValue as string,
    intakeForms,
  );

  if (emailMismatch) {
    actions.addError(IntakeFormErrorType.EMAIL_MISMATCH_WITH_INTAKE_FORM);
    bi?.report(
      bookingsBoWaiverAppSrc16Evid66({
        ...intakeFormsErrorDefaults,
        value: `${IntakeFormErrorType.EMAIL_MISMATCH_WITH_INTAKE_FORM}${intakeFormsErrorSuffixes.FIELD_CHANGE}`,
      }),
    );
  } else {
    actions.removeErrors([IntakeFormErrorType.EMAIL_MISMATCH_WITH_INTAKE_FORM]);
  }
};
